import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isDatePicker(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.DATE_PICKER && typeof label === 'string' && typeof value === 'string';
}
export function formatDatePicker(submission) {
  if (isDatePicker(submission) && submission.value) {
    var _submission$field$vie;
    return {
      label: (_submission$field$vie = submission.field.view) == null ? void 0 : _submission$field$vie.label,
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=date-picker-preview.js.map